module.exports = __webpack_public_path__ + "img/AL801-1-EN.527aaf3c.jpg";